import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const buttonDefaultVariants = {
  "appearance": "default",
  "size": "default"
}
const buttonCompoundVariants = [
  {
    "size": "default",
    "iconBefore": true,
    "css": {
      "container": {
        "ps": "3"
      }
    }
  },
  {
    "size": "default",
    "iconAfter": true,
    "css": {
      "container": {
        "pe": "3"
      }
    }
  },
  {
    "size": "small",
    "iconBefore": true,
    "css": {
      "container": {
        "ps": "2"
      }
    }
  },
  {
    "size": "small",
    "iconAfter": true,
    "css": {
      "container": {
        "pe": "2"
      }
    }
  },
  {
    "size": "large",
    "iconBefore": true,
    "css": {
      "container": {
        "ps": "5"
      }
    }
  },
  {
    "size": "large",
    "iconAfter": true,
    "css": {
      "container": {
        "pe": "5"
      }
    }
  },
  {
    "size": "xlarge",
    "iconBefore": true,
    "css": {
      "container": {
        "ps": "7"
      }
    }
  },
  {
    "size": "xlarge",
    "iconAfter": true,
    "css": {
      "container": {
        "pe": "7"
      }
    }
  }
]

const buttonSlotNames = [
  [
    "container",
    "button__container"
  ],
  [
    "icon",
    "button__icon"
  ]
]
const buttonSlotFns = /* @__PURE__ */ buttonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, buttonDefaultVariants, getSlotCompoundVariant(buttonCompoundVariants, slotName))])

const buttonFn = memo((props = {}) => {
  return Object.fromEntries(buttonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const buttonVariantKeys = [
  "appearance",
  "size",
  "iconBefore",
  "iconAfter"
]
const getVariantProps = (variants) => ({ ...buttonDefaultVariants, ...compact(variants) })

export const button = /* @__PURE__ */ Object.assign(buttonFn, {
  __recipe__: false,
  __name__: 'button',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: buttonVariantKeys,
  variantMap: {
  "appearance": [
    "default",
    "primary",
    "subtle",
    "hollow"
  ],
  "size": [
    "default",
    "xlarge",
    "large",
    "small"
  ],
  "iconBefore": [
    "true"
  ],
  "iconAfter": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, buttonVariantKeys)
  },
  getVariantProps
})